module.exports = __webpack_public_path__ + "assets/img/Automaticawarding.3fde8ae1.png";